import { Controller } from "stimulus";

import { flashSuccess, flashWarning } from "../legacy/admin/flash";

export default class extends Controller {
  static values = { text: String, element: String };

  copy() {
    let text = null;
    if (this.hasElementValue) {
      text = document.getElementById(this.elementValue).textContent;
    } else if (this.hasTextValue) {
      text = this.textValue;
    } else {
      text = this.element.textContent;
    }
    navigator.clipboard.writeText(text).then(
      function () {
        flashSuccess("Copied to clipboard!");
      },
      function () {
        flashWarning("Could not copy to clipboard...");
      }
    );
  }
}
